// extracted by mini-css-extract-plugin
module.exports = {"posts":"blog-module--posts--a25pe","newTitle":"blog-module--newTitle--1pas-","h2Summery":"blog-module--h2Summery--3QOjo","post":"blog-module--post--1jMia"};